import { Box, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';
import { ProgramContent } from '~/features/program/models/program-content';

type ProgramAboutSectionProps = NonNullable<StaticProgramAboutSectionProps>;

export function ProgramAboutSection({ aboutText }: ProgramAboutSectionProps) {
  if (!aboutText) return null;
  return (
    <Box as='section'>
      <ContentContainer>
        <Heading
          as='h2'
          mb={4}
          size={{
            base: 'heading-6',
            md: 'heading-5',
          }}
        >
          About this program
        </Heading>
        <Markdown markdownText={aboutText} />
      </ContentContainer>
    </Box>
  );
}

export function transformStaticProgramAboutSectionProps({ programContent }: { programContent: ProgramContent }) {
  if (!programContent.about) {
    return null;
  }

  return {
    aboutText: programContent.about,
  };
}

export type StaticProgramAboutSectionProps = ReturnType<typeof transformStaticProgramAboutSectionProps>;
